import { z } from "zod";

/** Jeden id w URL bywa liczbą (parser Routera); CSV jest stringiem. */
export const excludedIdfirmsSearchSchema = z
	.union([z.string(), z.number()])
	.transform(String)
	.refine((raw) => /^[1-9][0-9]*(,[1-9][0-9]*)*$/.test(raw))
	.refine((raw) => raw.split(",").every((id) => Number.isSafeInteger(Number(id))))
	.transform((raw) => [...new Set(raw.split(",").map(Number))].sort((a, b) => a - b).join(","))
	.optional()
	.catch(undefined);

/**
 * Wykluczenia należące do bieżącego zakresu. URL zachowuje pozostałe, żeby
 * powrót do poprzedniego zakresu przywrócił wybór; zapytania, etykiety
 * i eksporty widzą tylko te, które realnie zmieniają populację. Bez listy
 * opcji (ładowanie, błąd) zostaje pełny zbiór — backend i tak odejmuje
 * wyłącznie apteki z `scope ∩ visible_idfirms`.
 */
export function excludedIdfirmsInScope(
	excludedIdfirms: string | undefined,
	pharmacies: ReadonlyArray<{ idfirm: number }> | undefined,
): string | undefined {
	if (!excludedIdfirms || !pharmacies) return excludedIdfirms;
	const inScope = new Set(pharmacies.map((p) => p.idfirm));
	const ids = excludedIdfirms.split(",").filter((id) => inScope.has(Number(id)));
	return ids.length ? ids.join(",") : undefined;
}

/** Arkusz „Kryteria”: pełna lista `idfirm`, żeby eksport dało się odtworzyć. */
export function dashboardPharmacyLabel(scopeLabel: string, excludedIdfirms?: string): string {
	return excludedIdfirms ? `${scopeLabel} · pominięte apteki: ${excludedIdfirms}` : scopeLabel;
}

/** Linia kontekstu na ekranie: sama liczba — lista po „Odznacz wszystkie” zajmowała kilka linii. */
export function dashboardPharmacyScreenLabel(scopeLabel: string, excludedIdfirms?: string): string {
	if (!excludedIdfirms) return scopeLabel;
	const count = excludedIdfirms.split(",").length;
	return `${scopeLabel} · bez ${count} ${count === 1 ? "apteki" : "aptek"}`;
}
